var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.reports,"items-per-page":10,"sort-by":['name']},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('action-slot-component',{attrs:{"item":item,"route-name":"reports.export","route-params":{ type: item.type }},on:{"show":function($event){return _vm.$emit('show', item)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }